var app = angular.module('app');
app.controller('appCtrl', [
    "$scope",
    "$firebaseArray",
    "$q",
    "$firebaseAuth",
    function($scope, $firebaseArray, $q, $firebaseAuth) {
        var ref = firebase.database().ref();
        $scope.authObj = $firebaseAuth();
        $scope.canSubmit = false;
        $scope.authObj.$onAuthStateChanged(function(firebaseUser) {
            $scope.firebaseUser = firebaseUser;
            if (firebaseUser) firebaseUser.getIdTokenResult().then(function(idTokenResult) {
                $scope.$apply(function() {
                    var isAdmin = !!idTokenResult.claims.admin;
                    var isSubmitter = idTokenResult.claims.role === 'kill-submitter';
                    $scope.canSubmit = isAdmin || isSubmitter;
                });
            });
            else $scope.canSubmit = false;
        });
        $scope.logout = function() {
            $scope.authObj.$signOut().then(function() {
                window.location.reload();
            });
        };
        $scope.expansions = $firebaseArray(ref.child("expansion"));
        $scope.zones = $firebaseArray(ref.child("zone"));
        $scope.bosses = $firebaseArray(ref.child("boss"));
        $scope.guilds = $firebaseArray(ref.child("guild"));
        $scope.currentExpansion = null;
        $scope.expansionZones = [];
        $scope.sortedGuilds = [];
        $scope.sortGuildsLegacy = function(guildsList) {
            // Sort by total kills (desc), then by expansion points (desc)
            guildsList.sort(function(a, b) {
                // Calculate total kills on the fly for sorting
                var aKills = Object.values(a.zoneProgress).reduce((sum, p)=>sum + p.x, 0);
                var bKills = Object.values(b.zoneProgress).reduce((sum, p)=>sum + p.x, 0);
                // Primary sort: total kills (descending)
                if (bKills !== aKills) return bKills - aKills;
                // Secondary sort: expansion points (descending)
                return b.expansionPoints - a.expansionPoints;
            });
        };
        $scope.sortGuildsByPoints = function(guildsList) {
            // Sort by expansion points (desc), then by expansion medal points (desc)
            var expansionId = $scope.currentExpansion ? $scope.currentExpansion.$id : null;
            guildsList.sort(function(a, b) {
                // Primary sort: expansion points (descending)
                var aExpansionPoints = Number(a.expansionPoints) || 0;
                var bExpansionPoints = Number(b.expansionPoints) || 0;
                if (bExpansionPoints !== aExpansionPoints) return bExpansionPoints - aExpansionPoints;
                // Secondary sort: expansion medal points (descending)
                var aMedalPoints = a.expansionMedalPoints && a.expansionMedalPoints[expansionId] ? Number(a.expansionMedalPoints[expansionId]) : 0;
                var bMedalPoints = b.expansionMedalPoints && b.expansionMedalPoints[expansionId] ? Number(b.expansionMedalPoints[expansionId]) : 0;
                return bMedalPoints - aMedalPoints;
            });
        };
        $scope.tooltip = {
            show: false,
            bosses: [],
            x: 0,
            y: 0
        };
        $scope.showBossTooltip = function(e, bosses) {
            if (!bosses || bosses.length === 0) return;
            $scope.tooltip.show = true;
            $scope.tooltip.bosses = bosses;
            var tooltipOffset = 15;
            var tooltipWidth = 222;
            var rightPosition = e.clientX + tooltipOffset;
            $scope.tooltip.x = rightPosition + tooltipWidth > window.innerWidth ? Math.max(0, e.clientX - tooltipOffset - tooltipWidth) : rightPosition;
            $scope.tooltip.y = e.clientY + 15;
        };
        $scope.hideBossTooltip = function() {
            $scope.tooltip.show = false;
        };
        function getQueryParam(param) {
            var search = window.location.search.substring(1);
            var vars = search.split('&');
            for(var i = 0; i < vars.length; i++){
                var pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) == param) return decodeURIComponent(pair[1]);
            }
            return null;
        }
        $q.all([
            $scope.expansions.$loaded(),
            $scope.zones.$loaded(),
            $scope.bosses.$loaded(),
            $scope.guilds.$loaded()
        ]).then(function() {
            var expId = getQueryParam('expansionId');
            if (expId) $scope.currentExpansion = $scope.expansions.$getRecord(expId);
            if (!$scope.currentExpansion) {
                for(var i = 0; i < $scope.expansions.length; i++)if ($scope.expansions[i].name === "Rise of Kunark") {
                    $scope.currentExpansion = $scope.expansions[i];
                    break;
                }
            }
            if (!$scope.currentExpansion && $scope.expansions.length > 0) $scope.currentExpansion = $scope.expansions[0];
            if ($scope.currentExpansion) {
                // Filter out zones for the current expansion context
                $scope.expansionZones = $scope.zones.filter(function(z) {
                    return z.expansion === $scope.currentExpansion.$id;
                });
                // Pre-calculate the total counts and ID's of bosses in each zone 
                // inside this expansion for simpler lookup when processing guilds
                var zoneBossCounts = {};
                var zoneBossIds = {};
                angular.forEach($scope.expansionZones, function(zone) {
                    var bossesInZone = $scope.bosses.filter(function(b) {
                        return b.zone === zone.$id;
                    });
                    zoneBossCounts[zone.$id] = bossesInZone.length;
                    zoneBossIds[zone.$id] = bossesInZone.map(function(b) {
                        return b.$id;
                    });
                });
                var guildsList = [];
                angular.forEach($scope.guilds, function(guild) {
                    var guildData = {
                        $id: guild.$id,
                        name: guild.name,
                        expansionPoints: guild.expansionPoints && guild.expansionPoints[$scope.currentExpansion.$id] ? guild.expansionPoints[$scope.currentExpansion.$id] : 0,
                        expansionMedalPoints: guild.expansionMedalPoints || {},
                        zoneProgress: {}
                    };
                    angular.forEach($scope.expansionZones, function(zone) {
                        var total = zoneBossCounts[zone.$id] || 0;
                        var defeated = 0;
                        var bossesInZone = [];
                        angular.forEach(zoneBossIds[zone.$id], function(bossId) {
                            var bossRec = $scope.bosses.$getRecord(bossId);
                            var isKilled = guild.bossProgression && guild.bossProgression[bossId] !== undefined;
                            if (isKilled) defeated++;
                            bossesInZone.push({
                                name: bossRec ? bossRec.name : 'Unknown Boss',
                                isKilled: isKilled
                            });
                        });
                        var isGold = guild.zoneMedals && guild.zoneMedals[zone.$id] ? guild.zoneMedals[zone.$id].gold || false : false;
                        var isSilver = guild.zoneMedals && guild.zoneMedals[zone.$id] ? guild.zoneMedals[zone.$id].silver || false : false;
                        var isBronze = guild.zoneMedals && guild.zoneMedals[zone.$id] ? guild.zoneMedals[zone.$id].bronze || false : false;
                        var isCleared = total > 0 && defeated === total;
                        var medalImage = null;
                        if (isGold) medalImage = window.medalImages.gold;
                        else if (isSilver) medalImage = window.medalImages.silver;
                        else if (isBronze) medalImage = window.medalImages.bronze;
                        else if (isCleared) medalImage = window.medalImages.cleared;
                        guildData.zoneProgress[zone.$id] = {
                            x: defeated,
                            y: total,
                            isCleared: isCleared,
                            bosses: bossesInZone,
                            medalImage: medalImage
                        };
                    });
                    guildsList.push(guildData);
                });
                // Apply legacy sorting for "Echoes of Faydwer" expansion
                if ($scope.currentExpansion && $scope.currentExpansion.name === "Echoes of Faydwer") $scope.sortGuildsLegacy(guildsList);
                else $scope.sortGuildsByPoints(guildsList);
                $scope.sortedGuilds = guildsList;
                $scope.$applyAsync();
            }
        });
    }
]);

//# sourceMappingURL=wuoshi-raid-progression.5ed858c4.js.map
